/* global BigInt */
import { PublicKey, SystemProgram } from '@solana/web3.js';
import { callDigitalAssets } from './digitalAssetsClient';
import feeMath from '../../functions/serviceFeePolicy.js';
export const { DEFAULT_SERVICE_FEE, decimalToAtomic, formatUnits, percentageToBasisPoints, calculateServiceFee } = feeMath;
export async function quoteServiceFee(wallet, kind, baseAmountAtomic, isNative, expectedVersion) {
    if (!Number.isInteger(expectedVersion)) throw new Error('Wait for service fees to load before continuing.');
    return callDigitalAssets('quoteServiceFee', { kind, baseAmountAtomic, isNative, expectedVersion }, wallet);
}
export function addSolServiceFee(transaction, payer, quote) {
    if (BigInt(quote.solFeeLamports) > 0n) transaction.add(SystemProgram.transfer({ fromPubkey: payer, toPubkey: new PublicKey(quote.treasuryWallet), lamports: BigInt(quote.solFeeLamports) }));
    return transaction;
}
export function serviceFeeReceipt(quote) {
    return { serviceFeeAtomic: quote.paymentFeeAtomic, serviceFeeLamports: quote.solFeeLamports, totalPaymentAtomic: quote.totalPaymentAtomic, feeTreasury: quote.treasuryWallet, feePolicyVersion: quote.version };
}
